import * as angular from 'angular';
import './puller-locations';
import './new-location-modal/new-location-modal';

angular.module('Row52.Views.Account.SellerRegistration.PullerLocations', [
    'Row52.Views.Account.SellerRegistration.PullerLocations.Ctrl',
    'Row52.Views.Account.SellerRegistration.PullerLocations.NewLocationModal'
]);